import { useRouteMatch, Link } from "react-router-dom";

import { Card, CardBody, CardTitle, CardText } from "reactstrap";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import iconNFT from "../../assets/img/NFT_Icon.png";

const MasterContractCover = (props) => {
	const { templates } = props;

	if (templates.length) {
		return templates.map((item) => {
			return (
				<Box key={item._id} sx={{ p: "1rem" }}>
					<Card>
						<CardBody>
							<CardTitle tag="h5">{item.type}</CardTitle>
						</CardBody>
						<Box
							component="div"
							sx={{
								px: "10px",
								width: "100%",
								height: "150px",
								backgroundImage: `url(${
									item.image?.includes("https://")
										? item.image
										: `${process.env.REACT_APP_IPFS_HOST}/${
												item?.customImage ?? item.image
										  }`
								})`,
								backgroundSize: "contain",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center",
								backgroundOrigin: "content-box",
							}}
						/>
						<CardBody>
							<Paper elevation={2} sx={{ p: "0.5rem" }}>
								<Typography
									sx={{
										fontFamily: "Montserrat",
										fontWeight: "300",
										fontSize: "0.75rem",
									}}
								>
									Master Contract name:
								</Typography>
								<CardText className="item-description">
									{item?.customName ?? item.name}
								</CardText>
							</Paper>
						</CardBody>
						<div className="item-options text-center">
							<Button
								sx={{ width: "100%" }}
								component={Link}
								className="btn-cart move-cart"
								to={`/library/master-contract/${item._id}`}
							>
								View
							</Button>
						</div>
					</Card>
				</Box>
			);
		});
	}
	return <Box>Have not tamplates</Box>;
};

export default MasterContractCover;
